export const fbase = {
    apiKey: "AIzaSyALwRUUIvDSGnEkubpP8JbbKTSwJeLDSOo",
    authDomain: "tibetism.firebaseapp.com",
    projectId: "tibetism",
    storageBucket: "tibetism.appspot.com",
    messagingSenderId: "1056149278723",
    appId: "1:1056149278723:web:70abfefadeaaf73e07fe36",
    measurementId: "G-DSQXMZTCJX"
}




export const authCredentials = { 
    username: "admin",
    password: "123456"
}

